// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormBuklet
{
	#app;
	#productId = null; // Инициализация свойства для хранения id спецтехники
	constructor(rootNode, productId): void
	{
		this.rootNode = document.querySelector(rootNode);
		this.#productId = productId;
	}
	// Метод для установки id спецтехники
	setProductId(productId): void
	{
		this.#productId = productId;
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form :product-id="productId"/>
				</div>
				`,
			data: () => ({
				productId: this.#productId // Передача id спецтехники в данные компонента
			}),
		});
		this.#app.mount(this.rootNode);
	}
}
